<template>
  <div id="statement_acceptance">
    <div class="acceptance_checkbox" :style="{
            color: colors.theme == 'dark' ? `#fff` : `#000`
        }">
      <input type="checkbox" name="acceptance" id="acceptance" v-model="checked" />
      <label for="acceptance" :style="{color: colors.theme == 'dark' ? `#fff` : `#000`}">
        <strong>{{$t("components.acceptance.acceptance_checkbox.strong1")}}</strong> {{$t("components.acceptance.acceptance_checkbox.span1")}}
      </label>
    </div>
    <div
      class="acceptance_button"
      :class="{disabled: !checked}"
      @click="next"
      :style="{
        background: checked ? `${colors.secondary}` : '#f4f4f4',
        color: checked ? '#fff' : '#bcc7ce'
      }"
    >
      <span>{{ $t("components.acceptance.button") }}</span>
      <div class="arrow-right"
      :style="{
          borderLeft: '6px solid #fff'
      }"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["index", "nextRouter"],
  data: function() {
    return {
      checked: false,
      indexAux: "",
      newIndex: "",
      colors: {}
    };
  },

  created() {
    this.colors = JSON.parse(localStorage.getItem("colors"));
    this.newIndex = this.index;
    // console.log("NewIndex", this.newIndex);
  },

  methods: {
    next() {
      if (this.checked) {
        if (this.newIndex != 2) {
          this.newIndex++;
          this.$emit("changeIndex");
          this.checked = !this.checked;
        } else {
          this.$router.push(this.nextRouter);
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#statement_acceptance {
  .acceptance_checkbox {
    display: flex;
    align-items: center;
    padding: 0 25px;
    height: 10vh;
    // background-color: rgba($color: #02f0e4, $alpha: 0.3);

    label {
      // color: #83037d;
      font-size: 19px;
      margin-left: 10px;

      strong {
        font-weight: 700;
      }
    }
  }
  .acceptance_button {
    display: flex;
    align-items: center;
    text-align: center;
    // height: 10vh;
    // color: #000;
    font-weight: 700;
    text-decoration: none;
    // background-color: #fff581;

    span {
      font-size: 15px;
      letter-spacing: 6px;
      text-transform: uppercase;
      width: 90%;
      position: relative;
      left: 15px;         
    }

    .arrow-right {
      width: 0;
      height: 0;
      border-top: 6px solid transparent;
      border-bottom: 6px solid transparent;
      border-left: 6px solid #000;
      width: 10%;
    }
  }

  .disabled {
    &:hover {
      cursor: not-allowed;
    }
    color: #bcc7ce;
    background-color: #f4f4f4;
  }
}

@media screen and (max-width: 400px) {
  #statement_acceptance {
    .acceptance_checkbox {
      span {
        font-size: 15px;
      }
    }
  }
}
</style>
